import ajax from "../assets/uilt/ajax";

let bank = {
  //add new bank account
  addBankAccount: (req) => {
    return ajax.post({
      url: "/back/bank/add-bank-account",
      param: req.param,
      success: req.success,
    });
  },

  // update bank Status
  updateBankStatus: (req) => {
    return ajax.post({
      url: "/back/bank/update-bank-status",
      param: req.param,
      success: req.success,
    });
  },

  /**分页查询完善的机构申请资料 */
  getBankPage: (req) => {
    return ajax.get({
      url: "/back/bank/get-bank-page",
      param: req.param,
      success: req.success,
    });
  },

  /* get Escrow account page */
  getEscrowAccountPage: (req) => {
    return ajax.get({
      url: "/back/bank/get-escrow-page",
      param: req.param,
      success: req.success,
    });
  },

  feedEscrowAccount: (req) => {
    return ajax.post({
      url: "/back/bank/feed-escrow-account",
      param: req.param,
      success: req.success,
    });
  },

  getEscrowInfoPage: (req) => {
    return ajax.get({
      url: "/back/bank/get-escrow-info-page",
      param: req.param,
      success: req.success,
    });
  },

  // get list of bank by name
  getAllBank: (req) => {
    return ajax.get({
      url: "/back/bank/get-all-bank",
      param: req.param,
      success: req.success,
    });
  },

  //update Bank account by ID
  updateById: (req) => {
    return ajax.post({
      url: "/back/bank/update-by-id",
      param: req.param,
      success: req.success,
    });
  },

  //Bank Info

  //add bank info apply
  addBankInfoApply: (req) => {
    return ajax.post({
      url: "/back/bank/add-bank-info-apply",
      param: req.param,
      success: req.success,
    });
  },

  /**分页查询完善的机构申请资料 */
  getBankInfoPage: (req) => {
    return ajax.get({
      url: "/back/bank/get-bank-info-page",
      param: req.param,
      success: req.success,
    });
  },

  /** get only Bank Deposit page */
  getBankDepositInfoPage: (req) => {
    return ajax.get({
      url: "/back/bank/get-bank-deposit-info-page",
      param: req.param,
      success: req.success,
    });
  },

  /** get only Bank Withdrawal page */
  getBankWithdrawalInfoPage: (req) => {
    return ajax.get({
      url: "/back/bank/get-bank-withdrawal-info-page",
      param: req.param,
      success: req.success,
    });
  },

  /** update validation status */
  disposeBankInfoApply: (req) => {
    return ajax.post({
      url: "/back/bank/dispose-bankInfoApply",
      param: req.param,
      success: req.success,
    });
  },
  //getBankPage: req => { return ajax.get({ url: "/back/bank/get-bank-page", param: req.param, success: req.success }) },
  /**分页查机构登录用户 */

  //getBankInfo: req => { return ajax.get({ url: "/back/bank/get-bankInfo", param: req.param, success: req.success }) },

  /**add Partner Transfer */
  partnerDeposit: (req) => {
    return ajax.post({
      url: "/back/bank/partner-deposit",
      param: req.param,
      success: req.success,
    });
  },

  updatePartnerDeposit: (req) => {
    return ajax.post({
      url: "/back/bank/update-partner-deposit",
      param: req.param,
      success: req.success,
    });
  },

  /**分页查询完善的机构申请资料 */
  getPartnerPage: (req) => {
    return ajax.get({
      url: "/back/bank/get-partner-page",
      param: req.param,
      success: req.success,
    });
  },

  // update bank Status
  updatePartnerStatus: (req) => {
    return ajax.post({
      url: "/back/bank/update-partner-status",
      param: req.param,
      success: req.success,
    });
  },

  /**add Remaining Balance Partners */
  addRemainingBalancePartners: (req) => {
    return ajax.post({
      url: "/back/bank/add-remaining-balance-partners",
      param: req.param,
      success: req.success,
    });
  },

  updateRemainingBalancePartners: (req) => {
    return ajax.post({
      url: "/back/bank/update-remaining-balance-partners",
      param: req.param,
      success: req.success,
    });
  },

  // update remaining balance partners status
  updateRemainingBalancePartnersStatus: (req) => {
    return ajax.post({
      url: "/back/bank/update-remaining-balance-partners-status",
      param: req.param,
      success: req.success,
    });
  },

  /**分页查询完善的机构申请资料 */
  getPartnerRemainingBalancePage: (req) => {
    return ajax.get({
      url: "/back/bank/get-partner-remaining-balance-page",
      param: req.param,
      success: req.success,
    });
  },

  //
};

export default bank;
